import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListState from "../Components/State/listState";
import AddState from "../Components/State/addState";
import EditState from "../Components/State/editState";
import ViewState from "../Components/State/viewState";
import ListCountryState from "../Components/State/listCountryState";

const StateRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route path="/state" element={<ListCountryState />}></Route>
      <Route path="/state-list/:id" element={<ListState />}></Route>
      <Route path="/state/add/:id" element={canAdd ? <AddState /> : <Navigate to={`/country`} replace />}></Route>
      <Route path="/state-list/edit/:id" element={canEdit ? <EditState /> : <Navigate to={`/country`} replace />}></Route>
      <Route path="/state-list/view/:id" element={<ViewState />}></Route>
    </Routes>
  );
};

export default StateRoutes;
